import AchievementsPage from '../components/achievements/AchievementsPage';

export default function Achievements() {
  return <AchievementsPage />;
}
